import { SegemntsScrollArea, SelectedItemsContainer } from "../../styles";
import { SegmentsChipItem } from "@similarweb/ui-components";
import { WEBSITE_ID } from "../../constants";
import { Border, SrollWrapper } from "./styles";

const ChipList = ({ selectedItems, onRemove }) => (
    <SrollWrapper>
        <SegemntsScrollArea>
            <SelectedItemsContainer>
                {selectedItems.map((selectedItem, i) => (
                    <SegmentsChipItem
                        key={i}
                        text={selectedItem.domain}
                        secondaryText={selectedItem.segmentName}
                        image={selectedItem.favicon || selectedItem.image}
                        imageAlt={selectedItem.domain}
                        onRemove={() => onRemove(selectedItem)}
                        isWebsite={selectedItem?.type !== WEBSITE_ID}
                    />
                ))}
                <Border />
            </SelectedItemsContainer>
        </SegemntsScrollArea>
    </SrollWrapper>
);

export default ChipList;
